import React, {useEffect, useState} from "react";
import mqtt from "mqtt";
import moment from "moment-jalaali";
//const JSEncrypt = require("jsencrypt");
const Chat2 = () => {

    const publish = ()=>{
        //let encrypt = new JSEncrypt.JSEncrypt();
        let encrypt = {}
        encrypt.setPublicKey("-----BEGIN PUBLIC KEY-----\n" +
            "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCorqgGMLEEfFtLKJOBn2b3L9UL\n" +
            "n6EqT9bcoEE2qByG0X7OmIKk+tmo4sspXqbE2jNL1b/kqfPO22MkUAEEZHr6SbEx\n" +
            "gJdc3AjNOOkpxAY3luyxiU5iLK2WAu7Ag+u6DmKhJZvgagPVHUdsAzukU1qOGt2Z\n" +
            "UilBu/4++WnaLmlGzQIDAQAB\n" +
            "-----END PUBLIC KEY-----\n");
        let encrypted = encrypt.encrypt("heeeeey");
        console.log("Enc : ",encrypted)



        cli.publish(
            "FFF3455",
            JSON.stringify({
                message:encrypted,
                type:"admin"
            }),
            {qos: 2},
            async (error) => {
                console.log(error)
            })

    }


    const [cli,setCli] = useState(null);

    let WebSocket_URL = "wss://chat-stage.digimaall.com:443/mqtt"
    let topic = "aVyPuDWZ8n-u:Exkw9ZupDc-p:vrUDKdET67";
    let topic2 = "FFF3455";

    useEffect(()=>{
        const client = mqtt.connect(WebSocket_URL);
        setCli(client);

        client.on('connect', ()=>{
            console.log('Connected to', WebSocket_URL)

            client.subscribe(topic, (err) => {
                if(err){
                    console.log(err.toString())
                }else {
                    console.log("Subscribe topic 1 Success")
                }
            })

            client.subscribe(topic2, (err) => {
                if(err){
                    console.log(err.toString())
                }else {
                    console.log("Subscribe topic 2 Success")
                }
            })


        })

        client.on('message', (topic, message) => {
            let mes = message.toString();
            console.log('Chat2 : Received form', topic, ':', mes);
            // Decrypt with the private key...

            let encrypted = JSON.parse(mes);
            //var decrypt = new JSEncrypt.JSEncrypt();
            var decrypt = {};
            decrypt.setPrivateKey("-----BEGIN RSA PRIVATE KEY-----\n" +
                "MIICXAIBAAKBgQCorqgGMLEEfFtLKJOBn2b3L9ULn6EqT9bcoEE2qByG0X7OmIKk\n" +
                "+tmo4sspXqbE2jNL1b/kqfPO22MkUAEEZHr6SbExgJdc3AjNOOkpxAY3luyxiU5i\n" +
                "LK2WAu7Ag+u6DmKhJZvgagPVHUdsAzukU1qOGt2ZUilBu/4++WnaLmlGzQIDAQAB\n" +
                "AoGAE+dP8jMKoCHgT9UA2rmpV59wPwfd53U2QCA0sbNScmID2XLLb5Yd2rywBjih\n" +
                "6vZoORmGo/+dwhnG8AD0rcUBcZf4CL9fue7E7U4lxbwiSyARjdQM45J/g5QbKVtr\n" +
                "0CxhghtmTY9ofAsuZLbQEvD7WldLie19kD4RvuhTiAtD7m0CQQDQlM4hVDoYUaye\n" +
                "J1gmyHSd8SRwSRHSkM/hZx1W1LMgAUp0IaEFYdSIsTM6rgykU/340y9XcxUdOYBJ\n" +
                "4y/iDdnHAkEAzwfF8eayY+GhrY7f0b6hW/GXCtQABtnM3STN1DsXeijYd6mwMONv\n" +
                "hqKbQ3p/x7ZOXYBCjOtqcGwOw5K0ATW6ywJAHacaCujzfWOXG8DSKmlTEuUmXgQ1\n" +
                "UW8e7pd/N0nz0Tf9wrbJMn+u/GPcuZnm2DHMqGQ1lcQZm1cCYv62XvfDHwJAcSre\n" +
                "mQxyFwcPSb//uLdrnMbCubiJCzWjNn8XxBtJCg2pxj+LgC3SmNXp6Ujc8F5HF/U0\n" +
                "a7ODy1BGAcH/g2nLYQJBAKzXr+phLxA0AdmTeCYPhtithg9gWtgeUMWwFes64j4Q\n" +
                "cNyiBU9IRhhP9f8eDhRQtfp4PRiWL2bmT5dMXglSnq0=\n" +
                "-----END RSA PRIVATE KEY-----");
            var uncrypted = decrypt.decrypt(encrypted.message);
            console.log("EncS : ",uncrypted)
        })



    },[])

   return(
       <div>
           <span onClick={()=>{
               console.log("publish")
               publish();
           }}>send</span>
       </div>
   )

}
export {Chat2}
